import {useMutation, useQueryClient} from 'react-query';
import PatchToolAdvertisement from '.';
import {AxiosError} from 'axios';
import {toast} from 'react-toastify';

interface IPatchToolAdvertisementProps {
  onSuccess?: (response: IAddedAdvertisementResponse) => void;
  guid?: string;
}

const usePatchToolAdvertisement = ({
  onSuccess,
  guid,
}: IPatchToolAdvertisementProps) => {
  const queryClient = useQueryClient();

  const {isLoading, mutate, isSuccess} = useMutation({
    mutationFn: (payload: IToolAdvertisementPayload) => {
      return PatchToolAdvertisement(payload, guid);
    },

    onSuccess: data => {
      if (onSuccess) {
        onSuccess(data); // Passing the response to onSuccess
      }

      queryClient.invalidateQueries({queryKey: ['my-ads']}); // Invalidate personal ads
      queryClient.invalidateQueries({queryKey: ['get-store-lab-views']}); // Invalidate store ads
    },

    onError: (error: AxiosError<IAxiosErr>) => {
      toast.error(
        error?.response?.data?.message ||
          'مشکلی پیش آمده ،لطفا در زمان دیگری مراجعه فرمایید',
      );
    },
  });

  return {isLoading, mutate, isSuccess};
};

export {usePatchToolAdvertisement};
